export default __webpack_public_path__ + "static/media/apple-touch-icon-152x152.792aff6f.png";